<template>
<span class="range-slider" :class="{ disabled }" :data-min="`${_o_min}${icon}`" :data-max="`${_o_max}${icon}`">
    <span class="range-outer-rail"></span>
    <drag-helper
        v-bind:disabled="disabled"
        @dragstart="dragStart"
        @drag="drag"
        @dragend="dragEnd">
        <span ref="inner" class="range-slider-inner"
              :style="{ width: selectableLength + '%', left: selectableStartPoint + '%'}">
            <input class="range-slider-hidden" type="text" :name="name" :value="actualValue" :disabled="disabled">
            <span class="range-slider-rail" :style="{background: color}"></span>
            <span class="range-rec-rail"
                  :style="{ width: recommendedLength + '%', left: recommendedStartPoint + '%', background: recColor}"></span>
            <span class="range-slider-fill" :style="{ width: knobLeft + '%' }"></span>
            <span class="range-slider-knob" ref="knob" :style="{ left: knobLeft + '%' }"
                  :data-val="`${actualValue}${icon}`">
                <slot name="knob"></slot>
            </span>
        </span>
    </drag-helper>
</span>
</template>

<script>
    import DragHelper from './DragHelper';
    import {round} from './utils';

    export default {
        props: {
            name: String,
            value: [String, Number],
            disabled: {
                type: Boolean,
                default: false
            },
            min: {
                type: [String, Number],
                default: 0
            },
            max: {
                type: [String, Number],
                default: 100
            },
            outerMin: {
                type: [String, Number],
                default: null
            },
            outerMax: {
                type: [String, Number],
                default: null
            },
            recMin: {
                type: [String, Number],
                default: null
            },
            recMax: {
                type: [String, Number],
                default: null
            },
            step: {
                type: [String, Number],
                default: 1
            },
            color: {
              type: String,
              default: '#f4cc46',
            },
            recColor: {
              type: String,
              default: '#45ae5d',
            },
            icon: {
                type: [String, Number],
                default: ''
            },
            roundVal: {
                type: Boolean,
                default: true
            },
            x: {
                type: Boolean,
                default: false
            },
        },
        components: {
            DragHelper
        },
        data() {
            return {
                actualValue: null,
                dragStartValue: null
            }
        },
        created() {
            const {_min: min, _max: max} = this;

            let defaultValue = Number(this.value);
            if (this.value == null || isNaN(defaultValue)) {
                if (min > max) {
                    defaultValue = min;
                } else {
                    defaultValue = (min + max) / 2;
                }
            }
            this.actualValue = this.roundVal ? this.round(defaultValue) : defaultValue;
        },
        computed: {
            _min() {
                return Number(this.min);
            },
            _max() {
                return Number(this.max);
            },
            _o_min() {
                return Number(this.outerMin !== null ? this.outerMin : this.min);// need to take this way to get 0 as numeric value
            },
            _o_max() {
                return Number(this.outerMax !== null ? this.outerMax : this.max);
            },
            _r_min() {
                return Number(this.recMin !== null ? this.recMin : this.min);// need to take this way to get 0 as numeric value
            },
            _r_max() {
                return Number(this.recMax !== null ? this.recMax : this.max);
            },
            _step() {
                return Number(this.step);
            },
            valuePercent() {
                return (this.actualValue - this._min) / (this._max - this._min) * 100;
            },
            knobLeft() {
                if (this.valuePercent < 0) {
                    return 0;
                }
                if (this.valuePercent > 100) {
                    return 100;
                }

                return this.valuePercent;
            },
            selectableLength() {
                return 100 - ((100 * ((this._o_max - this._o_min) - (this._max - this._min))) / this._o_max);
            },
            selectableStartPoint() {
                return ((this._min - this._o_min) * 100) / this._o_max;
            },
            recommendedLength() {
                return (100 * (this._r_max - this._r_min)) / (this._max - this._min);
                // return 100 - ((100 * ((this._max - this._min) - (this._r_max - this._r_min))) / this._max);
            },
            recommendedStartPoint() {
                return  100 - this.recommendedLength;
                // return ((this._r_min - this._min) * 100) / this._max;
            }
        },
        watch: {
            value(newValue) {
                const value = Number(newValue);
                if (newValue != null && !isNaN(value)) {
                    this.actualValue = this.roundVal ? this.round(value) : value;
                }
            },
            min(min) {
                this.actualValue = this.actualValue >= min ? this.round(this.actualValue) : min;
            },
            max(max) {
                this.actualValue = this.actualValue <= max ? this.round(this.actualValue) : max;
            },
            actualValue(value) {
                this.emitInput(this.actualValue);
            }
        },
        methods: {
            dragStart(event, offset) {
                this.dragStartValue = this.actualValue;
                if (event.target === this.$refs.knob) {
                    return;
                }
                // If the click is out of knob, move it to mouse position
                this.drag(event, offset);
            },
            drag(event, offset) {
                if (this.min !== this.max) {
                    const {offsetWidth} = this.$refs.inner;
                    this.actualValue = this.round(this.valueFromBounds(offset.left, offsetWidth));
                }
                // this.emitInput(this.actualValue);
            },
            dragEnd(event, offset) {
                if (this.min !== this.max) {
                    const {offsetWidth} = this.$refs.inner;
                    this.actualValue = this.round(this.valueFromBounds(offset.left, offsetWidth));
                    if (this.dragStartValue !== this.actualValue) {
                        this.emitChange(this.actualValue);
                    }
                }
            },
            emitInput(value) {
                this.$emit('input', value);
            },
            emitChange(value) {
                this.$emit('change', value);
            },
            valueFromBounds(point, width) {
                return (point / width) * (this._max - this._min) + this._min;
            },
            round(value) {
                return round(value, this._min, this._max, this._step);
            }
        },
    }
</script>

